// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1t4db","spacer":"styles_spacer__2u5fI","logo":"styles_logo__-nCDy","expiryText":"styles_expiryText__1m_8J"};